import { Anchor, Box, Button, Heading, Modal, Paragraph } from '@zillow/constellation-10';

type Brand = 'zillow' | 'hotpads';

type CustomizedBlockedUserModalProps = {
  brand: Brand;
};

const EMAIL_MAP: Record<Brand, string> = {
  zillow: 'account_verification@zillow.com',
  hotpads: 'account_verification@hotpads.com',
};

const BRAND_DISPLAY_NAME: Record<Brand, string> = {
  zillow: 'Zillow',
  hotpads: 'HotPads',
};

export default function CustomizedBlockedUserModal({ brand }: CustomizedBlockedUserModalProps) {
  const email = EMAIL_MAP[brand];
  const brandDisplayName = BRAND_DISPLAY_NAME[brand];

  return (
    <Modal
      open={true}
      closeButton={false}
      size={{
        base: 'fullScreen',
        lg: 'md',
      }}
      header={
        <Heading level={2} textStyle="heading-xs" css={{ textAlign: 'center', paddingLeft: 'loose' }}>
          Alert
        </Heading>
      }
      body={
        <Box css={{ textAlign: 'center' }}>
          <Paragraph textStyle="body-bold" css={{ paddingBottom: 'loose' }}>
            Your account is currently disabled
          </Paragraph>
          <Paragraph css={{ paddingBottom: 'loose' }}>
            We are unable to access your inbox at this time. Please contact{' '}
            <Anchor href={`mailto:${email}`}>{email}</Anchor> to resolve the issue.
          </Paragraph>
          <Box css={{ marginBottom: 'default' }}>
            <Button asChild emphasis="filled" tone="brand">
              <a href={`https://www.${brand}.com`}>Return to {brandDisplayName}</a>
            </Button>
          </Box>
        </Box>
      }
      useDismissProps={{
        escapeKey: false,
        outsidePress: false,
      }}
    />
  );
}
